// extracted by mini-css-extract-plugin
export default {"error":"Select_error__67nQp","label":"Select_label__njdyC"};